import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import {
    Entity,
    CreateEntityRequest,
    UpdateEntityRequest,
} from "../models/entity.model";
import { User } from "../models/auth.model";

export type { Entity, CreateEntityRequest, UpdateEntityRequest };

@Injectable({
    providedIn: "root",
})
export class EntityService {
    private apiUrl = `${environment.apiUrl}/api/v1/entity`;

    constructor(private http: HttpClient) { }

    getEntities(): Observable<Entity[]> {
        return this.http.get<Entity[]>(`${this.apiUrl}`);
    }

    getEntityById(id: number): Observable<Entity> {
        return this.http.get<Entity>(`${this.apiUrl}/${id}`);
    }

    createEntity(
        entity: CreateEntityRequest
    ): Observable<Entity> {
        return this.http.post<Entity>(`${this.apiUrl}`, entity);
    }

    createEntityOnFirstLogin(
        entity: CreateEntityRequest
    ): Observable<{ entity: Entity; user: User; access_token: string; expires_at: string }> {
        return this.http.post<{ entity: Entity; user: User; access_token: string; expires_at: string }>(
            `${environment.apiUrl}/api/v1/auth/create-entity`,
            entity
        );
    }

    updateEntity(
        id: number,
        entity: UpdateEntityRequest
    ): Observable<Entity> {
        return this.http.put<Entity>(`${this.apiUrl}/${id}`, entity);
    }

    deleteEntity(id: number): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${id}`);
    }
}

